<template>
  <div>
    <el-button @click="getStatus">update</el-button>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane
        class="paddingBody content"
        :label="$t('Riesgos pendientes')"
        v-loading="loading"
        element-loading-text="Actualizando tareas..."
        element-loading-background="rgba(255, 255, 255)"
      >
        <el-table
          empty-text="No hay tareas que requieran su revisión"
          :data="paginarTareas()"
          style="width: 100%"
          header-cell-class-name="header-cell-class-table-gray"
          stripe
        >
          <el-table-column type="expand" width="110" label="Detalles">
            <template slot-scope="scope">
              <el-table
                border
                :header-cell-style="function () { return 'background-color: rgb(7, 116, 141); color: white; padding: 0px;'}"
                empty-text="Sin riesgos registrados"
                class="tableRisks"
                :data="getRisks(scope.row.tarea_id)"
                style="width: 100%"
                header-cell-class-name="headerCell"
              >
                <el-table-column width="130" align="center" label="Acciones">
                  <template slot-scope="scope">
                    <el-button
                      size="small"
                      plain
                      type="danger"
                      @click="deleteRisk(scope.row)"
                      icon="el-icon-delete"
                    />
                    <el-button
                      size="small"
                      plain
                      type="info"
                      @click="openEditRisk(scope.row)"
                      icon="el-icon-edit"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="nombre" label="Nombre" />
                <el-table-column width="150" align="center" label="Categoría">
                  <template slot-scope="scope">{{scope.row.tipo ? MaysPrimera(scope.row.tipo) : ""}}</template>
                </el-table-column>
                <el-table-column align="center" label="Sin Controles">
                  <el-table-column width="150" align="center" label="Severidad">
                    <template
                      slot-scope="scope"
                    >{{(scope.row.sin_controles && scope.row.sin_controles.severidad) ? scope.row.sin_controles.severidad : "---"}}</template>
                  </el-table-column>
                  <el-table-column width="150" align="center" label="Probabilidad">
                    <template
                      slot-scope="scope"
                    >{{(scope.row.sin_controles && scope.row.sin_controles.probabilidad) ? scope.row.sin_controles.probabilidad : "---"}}</template>
                  </el-table-column>
                  <el-table-column width="150" align="center" label="Indice de Riesgo">
                    <template
                      slot-scope="scope"
                    >{{(scope.row.sin_controles && scope.row.sin_controles.probabilidad && scope.row.sin_controles.severidad) ? (scope.row.sin_controles.probabilidad * scope.row.sin_controles.severidad) : "---"}}</template>
                  </el-table-column>
                </el-table-column>
                <el-table-column align="center" label="Con Controles">
                  <el-table-column width="150" align="center" label="Severidad">
                    <template
                      slot-scope="scope"
                    >{{(scope.row.con_controles && scope.row.con_controles.severidad) ? scope.row.con_controles.severidad : "---"}}</template>
                  </el-table-column>
                  <el-table-column width="150" align="center" label="Probabilidad">
                    <template
                      slot-scope="scope"
                    >{{(scope.row.con_controles && scope.row.con_controles.probabilidad) ? scope.row.con_controles.probabilidad : "---"}}</template>
                  </el-table-column>
                  <el-table-column width="150" align="center" label="Indice de Riesgo">
                    <template
                      slot-scope="scope"
                    >{{(scope.row.con_controles && scope.row.con_controles.probabilidad && scope.row.con_controles.severidad) ? (scope.row.con_controles.probabilidad * scope.row.con_controles.severidad) : "---"}}</template>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="N° de riesgos" align="center" width="150">
            <template slot-scope="scope">
              <el-tag>{{getRisks(scope.row.tarea_id).length}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="nombre_contrato" label="Nombre del inventario"></el-table-column>
          <el-table-column prop="tarea_nombre" label="Nombre de la tarea"></el-table-column>
          <el-table-column label="Comentarios" align="center" width="220">
            <template slot-scope="scope">
              <el-badge
                v-if="scope.row.comentarios.length > 0"
                :value="scope.row.comentarios.length"
                class="item"
              >
                <el-button
                  plain
                  type="primary"
                  size="medium"
                  @click="viewComentarios(scope.row.comentarios)"
                >Visualizar Comentarios</el-button>
              </el-badge>
              <el-tag type="primary" v-else>SIN COMENTARIOS</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Operaciones" width="350" align="center">
            <template slot-scope="scope">
              <el-button
                plain
                @click="openDialogVerificarEstado(scope.row)"
                v-if="$store.getters.role.admin || ($store.getters.role.role !== 'coordinator' && $store.getters.role.role !== 'contractor_coordinator')"
                type="primary"
                size="medium"
              >Revisar</el-button>
              <el-button
                plain
                v-if="$store.getters.role.admin || ($store.getters.role.role === 'coordinator' || $store.getters.role.role === 'contractor_coordinator')"
                type="primary"
                size="medium"
              >Modificar</el-button>
            </template>
          </el-table-column>
        </el-table>
        <br />
        <br />
        <center>
          <el-pagination
            @prev-click="backPage"
            @next-click="nextPage"
            @current-change="currentPage"
            :page-size="4"
            layout="prev, pager, next"
            :total="$store.getters.tareas_pendientes.tasks.length"
          ></el-pagination>
        </center>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="Historial de comentarios"
      :visible.sync="openDialogComentario"
      width="30%"
      :before-close="handleClose"
    >
      <br />
      <div style="max-height: 364px; overflow: auto;">
        <el-alert
          :closable="false"
          v-for="(item, index) in comentarios"
          :key="index"
          :title="item.fecha"
          type="info"
          style="font-size: 14px; margin-bottom: 20px;"
        >
          <template slot-scope="description">
            <p>
              <b>Revisor</b>
              <br />
              {{roles[item.revisor]}}
              <br />
              <br />
              <b>Comentario</b>
              <br />
              {{item.comentario}}
            </p>
          </template>
        </el-alert>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="openDialogComentario = false">Cerrar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      width="30%"
      :title="$t('REVISIÓN')"
      :visible="dialogVerificarEstado"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form
        label-position="top"
        v-loading="loading_revision"
        element-loading-text="Espere un momento ..."
        element-loading-background="rgba(255, 255, 255)"
      >
        <div>
          <el-form-item :label="$t('Estado')">
            <el-select
              v-model="checkTask"
              :placeholder="$t('Por favor revise la tarea')"
              size="large"
              class="with-help-box full-width"
            >
              <el-option :label="$t('Revisado sin comentarios')" :value="true"></el-option>
              <el-option :label="$t('Revisado con comentarios')" :value="false"></el-option>
            </el-select>
            <el-popover
              class="help-box"
              placement="top"
              :title="$t('Estado')"
              width="200"
              trigger="hover"
              :content="$t('Seleccione el estado de aprobación de la tarea. Si no aprueba la evaluación de la tarea, debe seleccionar \'Revisado con comentarios\'.')"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item label="Comentario" v-if="checkTask === false">
            <el-input
              class="with-help-box"
              placeholder="Ingrese su comentario"
              type="textarea"
              :rows="2"
              v-model="comentario"
            />
            <el-popover
              class="help-box"
              placement="top"
              title="Comentario"
              width="200"
              trigger="hover"
              :content="$t(`Especifique el motivo del rechazo de la tarea para que
              el  \'Coordinador \' corrija el riesgo.`)"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">{{$t('Cancelar')}}</el-button>
        <el-button
          :loading="loading_revision"
          type="primary"
          @click="saveVerificarEstado()"
        >{{$t('Guardar')}}</el-button>
      </span>
    </el-dialog>

    <!-- <el-dialog
      top="15px"
      :before-close="closeChangeRisk"
      :title="$t('Modificando Riesgo o Aspecto Ambiental')"
      width="99%"
      :visible="dialogChangeRiskVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <p>{{$t('A continuación puede modificar el riesgo según lo indicado por el revisor. Por favor, verifique bien antes de guardar.')}}</p>
      <InventarioBowtie
        :taskName="task.nombre"
        :editable="true"
        :editRisk="true"
        :risk="this.actualRisk"
        :addCause="addCause"
        :deleteCause="deleteCause"
        :editCause="editCause"
        :addImpact="addImpact"
        :deleteImpact="deleteImpact"
        :editImpact="editImpact"
        :addPreventiveControl="addPreventiveControl"
        :deletePreventiveControl="deletePreventiveControl"
        :editPreventiveControl="editPreventiveControl"
        :addMitigationControl="addMitigationControl"
        :deleteMitigationControl="deleteMitigationControl"
        :editMitigationControl="editMitigationControl"
        :addEvaluator="addEvaluator"
        :deleteEvaluator="deleteEvaluator"
        :editEvaluator="editEvaluator"
      />

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeChangeRisk()">{{$t('Cancelar')}}</el-button>
        <el-button type="primary" @click="saveRisk()">{{$t('Guardar')}}</el-button>
      </span>
    </el-dialog>-->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import uuid from "uuid/v4";
import InventarioBowtie from "@/components/InventarioBowtie.vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading_revision: false,
      allTasks: [],
      data_task: {},
      checkTask: true,
      dialogVerificarEstado: false,
      comentario: "",
      loading: false,
      roles: {
        superadmin: "Superadministrador",
        contractor_coordinator: "Coordinador contratista",
        contractor_hse: "HSE Contratista",
        administrator: "Administrador de contratos",
        coordinator: "Coordinador",
        owner: "Dueño de contrato",
        risk: "Especialista de riesgos",
        hse: "HSE",
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente"
      },
      page: 1,
      comentarios: [],
      openDialogComentario: false
    };
  },
  components: {
    InventarioBowtie
  },
  created() {
    if (!this.$store.getters.tareas_pendientes) {
      this.$router.push({ name: "dashboardPersonal" });
    }
    this.$store.dispatch("setTitle", "Listado de riesgos pendientes");
    this.$store.dispatch("setSubTitle", "Inventario de riesgos HSE online");
    this.getDataTasks();
  },
  methods: {
    ...mapGetters({
      actualRole: "actualRole"
    }),
    getRisks(id) {
      var riesgos = this.allTasks.find(x => x._id === id || x.id === id);
      if (riesgos) {
        return this.allTasks.find(x => x._id === id || x.id === id).riesgos;
      } else {
        return [];
      }
    },
    MaysPrimera(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getControlesMitigadores(risk) {
      const controles = [];

      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;

          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach(control => {
              control.id_impacto = id;
              controles.push(control);
            });
          }
        });
      }

      return controles;
    },
    async saveVerificarEstado() {
      this.loading_revision = true;
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      };
      const response_task = await axios.post(
        `/inventarios/getTaskById/${this.data_task.tarea_id}/${this.data_task.inv_id}`,
        {},
        config
      );
      var actualTask = response_task.data;
      actualTask.ultimo_revisor = `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
      actualTask.ultimo_rol_revisor = this.actualRole;
      actualTask.ultima_revision = this.$moment().format("LLLL");
      const response_workflow = await axios.post(
        `/inventarios/getWorkflowByContract/${this.data_task.id_contrato}`,
        {},
        config
      );
      var workflow = response_workflow.data;

      this.loading_revision = false;

      if (this.checkTask === true) {
        this.comentario = "";
        this.$confirm(
          this.$t(
            "¿Está seguro de esta revisión? Un email de aviso será enviado"
          ),
          this.$t("Atención"),
          { type: "warning" }
        ).then(() => {
          // Revision normal
          this.loading_revision = true;
          actualTask.revisores.push(this.actualRole);
          const task_id = actualTask._id;
          let paso_actual = workflow.pasos[actualTask.paso];
          if (paso_actual.minAprobaciones === actualTask.revisores.length) {
            if (!workflow.pasos[actualTask.paso + 1]) {
              actualTask.aprobado = true;
            } else {
              actualTask.paso = actualTask.paso + 1;
              actualTask.revisores = [];
            }
          }
          // aqui se envia
          this.$store
            .dispatch("updateTaskStatus", {
              id: this.data_task.inv_id,
              task_id: actualTask._id,
              task: actualTask
            })
            .then(async response => {
              if (response.status) {
                // busca si hay almenos 1 tarea sin aprobar
                const response_approved = await axios.post(
                  `/inventarios/updateStatusInventoryAll/${this.data_task.inv_id}`,
                  {},
                  config
                );
                if (response_approved.data) {
                  this.$alert(
                    "La tarea de actualizó correctamente.",
                    this.$t("Atención"),
                    {
                      type: "success"
                    }
                  );
                  this.closeDialogVerificarEstado();
                  this.loading_revision = false;
                  this.getStatus();
                } else {
                  this.loading_revision = false;
                  this.$alert(
                    this.$t(
                      "Lo sentimos, surgió un error al actualizar estado. Intente nuevamente."
                    ),
                    this.$t("Atención"),
                    {
                      type: "error"
                    }
                  );
                }
              } else {
                this.loading_revision = false;
                this.$alert(
                  this.$t(
                    "Lo sentimos, surgió un error al actualizar estado. Intente nuevamente."
                  ),
                  this.$t("Atención"),
                  {
                    type: "error"
                  }
                );
              }
            });
        });
      } else if (this.checkTask === false) {
        if (this.comentario === "") {
          this.$alert(
            this.$t(
              "No has ingresado ningún comentario, debes completar todos los campos para continuar."
            ),
            this.$t("Atención"),
            {
              type: "warning"
            }
          );
          this.loading_revision = false;
        } else {
          // Revision normal
          let fecha = this.$moment().format("LLLL");
          actualTask.revisores = [];
          actualTask.paso = -1;
          actualTask.comentarios.push({
            fecha: fecha,
            revisor: this.actualRole,
            comentario: this.comentario
          });
          actualTask.comentarios = actualTask.comentarios.reverse();
          const task_id = actualTask._id;
          // aqui se envia
          this.$store
            .dispatch("updateTaskStatus", {
              id: this.data_task.inv_id,
              task_id: actualTask._id,
              task: actualTask
            })
            .then(async response => {
              if (response.status) {
                const response_approved = await axios.post(
                  `/inventarios/updateStatusInventoryAll/${this.data_task.inv_id}`,
                  {},
                  config
                );
                if (response_approved.data) {
                  this.$alert(
                    "La tarea de actualizó correctamente.",
                    this.$t("Atención"),
                    {
                      type: "success"
                    }
                  );
                  this.closeDialogVerificarEstado();
                  this.loading_revision = false;
                  this.getStatus();
                } else {
                  this.loading_revision = false;
                  this.$alert(
                    this.$t(
                      "Lo sentimos, surgió un error al actualizar estado. Intente nuevamente."
                    ),
                    this.$t("Atención"),
                    {
                      type: "error"
                    }
                  );
                }
              } else {
                this.loading_revision = false;
                this.$alert(
                  this.$t(
                    "Lo sentimos, surgió un error al actualizar estado. Intente nuevamente."
                  ),
                  this.$t("Atención"),
                  {
                    type: "error"
                  }
                );
              }
            });
        }
      }
    },
    closeDialogVerificarEstado() {
      this.comentario = "";
      this.data_task = {};
      this.dialogVerificarEstado = false;
    },
    tablaControlCritico(risk) {
      if (risk.critico) {
        return "control-critico";
      }
    },
    getControlesPreventivos(risk) {
      const controles = [];
      const controlesId = {};

      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const id = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach(control => {
              if (!controlesId[control.nombre]) {
                controlesId[control.nombre] = true;
                control.id_causa = id;
                controles.push(control);
              }
            });
          }
        });
      }

      return controles;
    },
    tableRowClassName({ row, rowIndex }) {
      if (
        row.status_update &&
        row.status_update.status === true &&
        !this.isCoordinatorRole(this.$store.getters.role.role)
      ) {
        return "warning-row";
      }
      return "";
    },
    openDialogVerificarEstado(task) {
      this.data_task = task;
      this.dialogVerificarEstado = true;
    },
    handleClose() {
      this.openDialogComentario = false;
      this.checkTask = true;
      this.dialogVerificarEstado = false;
      this.comentario = "";
    },
    viewComentarios(comentarios) {
      this.comentarios = comentarios;
      this.openDialogComentario = true;
    },
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    currentPage(page) {
      this.page = page;
      this.paginarTareas();
      this.getDataTasks();
    },
    nextPage(page) {
      this.page = page;
      this.paginarTareas();
      this.getDataTasks();
    },
    backPage(page) {
      this.page = page;
      this.paginarTareas();
      this.getDataTasks();
    },
    paginarTareas() {
      if (this.$store.getters.tareas_pendientes.tasks.length === 0) {
        return [];
      }

      return this.$store.getters.tareas_pendientes.tasks.slice(
        (this.page - 1) * 4,
        this.page * 4
      );
    },
    getDataTasks() {
      this.loading = true;
      var self = this;
      var tasks = this.$store.getters.tareas_pendientes.tasks
        .slice((this.page - 1) * 4, this.page * 4)
        .map(t => t.tarea_id);
      var inventories = [
        ...new Set(
          this.$store.getters.tareas_pendientes.tasks
            .slice((this.page - 1) * 4, this.page * 4)
            .map(t => t.inv_id)
        )
      ];
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      };
      axios
        .post(
          "/inventarios/getTasks",
          {
            ids: tasks,
            inventories: inventories
          },
          config
        )
        .then(function(response) {
          self.allTasks = response.data;
          self.loading = false;
        });
    },
    async getStatus() {
      var self = this;
      this.loading = true;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      };
      let role =
        this.$store.getters.role.admin === true
          ? "superadmin"
          : this.$store.getters.role.role;
      await axios
        .get(
          `/inventarios/getStatusDashboardAmsa/${this.$store.getters.role.faena_id}/${role}/${this.$store.getters.user._id}/${this.$store.getters.role.area_id}/${this.$store.getters.role.empresa_id}`,
          config
        )
        .then(function(response) {
          // handle success
          self.$store.dispatch("setAllTareasPendientes", response.data);
          var estructura = self.$store.getters.tareas_pendientes.structure.split(
            "."
          );
          var pendientes =
            response.data[estructura[0]][estructura[1]][estructura[2]][
              estructura[3]
            ];
          self.$store.dispatch("setTareasPendientes", {
            tasks: pendientes,
            structure: self.$store.getters.tareas_pendientes.structure
          });
          self.loading = false;
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.fullWidth {
  width: 100%;
}
.statusUpdatedAt {
  font-size: 10px;
  color: gray;
}
.nombre-riesgo {
  word-break: break-word;
}
.no-aplica {
  font-size: 12px;
  color: gray;
}
.green {
  background-color: #6bc45b;
}
.full-content {
  width: 100%;
}
</style>

<style>
.el-table__expanded-cell[class*="cell"] {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.el-dialog__body {
  padding: 0px 20px !important;
  color: #606266;
  font-size: 14px;
}
</style>